/* import __COLOCATED_TEMPLATE__ from './savings-balances.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { AccountState, Owner, OwnerType } from '@square/dashboard-protos/models/squareup/banking/common';
import { Action, getEvent, Target, Page } from '@banking/ui/utils/budgeting-smart-folders-cdp';
let SavingsBalances = (_dec = service('smart-folder-recommendation'), _class = class SavingsBalances extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor, this);
    _initializerDefineProperty(this, "bankingAccountApi", _descriptor2, this);
    _initializerDefineProperty(this, "bankingWithholdingConfigApi", _descriptor3, this);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor4, this);
    _initializerDefineProperty(this, "currentUserData", _descriptor5, this);
    _initializerDefineProperty(this, "dataApi", _descriptor6, this);
    _initializerDefineProperty(this, "features", _descriptor7, this);
    _initializerDefineProperty(this, "savingsApy", _descriptor8, this);
    _initializerDefineProperty(this, "smartFolderRecommendationService", _descriptor9, this);
  }
  get showMaxApy() {
    return this.features.isEnabled('banking-savings-hysa-phase-1');
  }
  get showSignup() {
    return this.args.customer && !this.args.customer.primaryAccountId;
  }
  get maskedAccountNumber() {
    const primaryAccount = this.args.balances.find(account => {
      return account.isPrimary;
    });
    if (primaryAccount?.accountNumberSuffix) {
      return `••• •${primaryAccount.accountNumberSuffix}`;
    } else {
      return '';
    }
  }
  get isClosed() {
    return this.args.primaryStatus === AccountState.CLOSED;
  }
  openCreateSubaccountFlow(event) {
    const {
      name,
      properties
    } = getEvent(Action.Click, {
      page: Page.BankingLauncher,
      target: Target.CustomFolder
    });
    this.dataApi.track(name, properties);
    this.args.onOpenCreateFolderFlow();
    event?.target?.deselect();
  }
  closeCreateSubaccountFlow() {
    this.args.onCloseCreateFolderFlow();
    this.automationSubaccountState.resetValues();
  }
  async refreshAccounts() {
    const accounts = await this.bankingAccountApi.listAccounts([Owner.create({
      type: OwnerType.MERCHANT,
      id: this.capitalEngineContext.sessionContext.merchantToken
    })], {
      reload: true,
      toggleLoading: false
    });
    const accountIds = accounts.map(account => account.id);
    await this.bankingWithholdingConfigApi.list(accountIds);
    if (this.args.hasRecommendedFolders) {
      await this.refreshRecommendedFolders();
    }
  }
  async refreshRecommendedFolders() {
    await this.smartFolderRecommendationService.listRecommendedFolders(Owner.create({
      type: OwnerType.MERCHANT,
      id: this.capitalEngineContext.sessionContext.merchantToken
    }));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bankingAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "bankingWithholdingConfigApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "currentUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "savingsApy", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "smartFolderRecommendationService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "openCreateSubaccountFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openCreateSubaccountFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeCreateSubaccountFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeCreateSubaccountFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshAccounts", [action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshRecommendedFolders", [action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshRecommendedFolders"), _class.prototype), _class);
export { SavingsBalances as default };